import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import Slider from '@mui/material/Slider'
import DateUtils from '../../inumet_js_lib/utils/dateUtils'
import Periodicidad from '../../inumet_js_lib/model/tipos/periodicidad'
import { Button, Grid2 as Grid, LinearProgress } from '@mui/material'
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'

const BUTTONS_PLAYER_SIZE = 'auto'
const SPACING_SIZE = 1

const SliderFechas = ({
    index,
    loading,
    fechas,
    formato,
    periodicidad,
    onClickForward,
    onClickBack,
    onChange,
    textoAvanzaTiempoCustom,
    textoRetrocedeTiempoCustom,
    fechasMarksCustom,
    hintAbajo,
}) => {
    //let [index, setIndex] = useState(-1)
    let [textoAvanzaTiempo, setTextoAvanzaTiempo] = useState('+1')
    let [textoRetrocedeTiempo, setTextoRetrocedeTiempo] = useState('-1')
    let [fechasMarks, setFechasMarks] = useState([])

    // Creo los textos de los botones para avanzar y retroceder una unidad de tiempo
    // La unidad de tiempo se define segun la periodicidad dada
    useEffect(() => {
        if (textoAvanzaTiempoCustom && textoRetrocedeTiempoCustom) {
            setTextoAvanzaTiempo(textoAvanzaTiempoCustom)
            setTextoRetrocedeTiempo(textoRetrocedeTiempoCustom)
        } else if (periodicidad === Periodicidad.hour) {
            setTextoAvanzaTiempo('+1Hr')
            setTextoRetrocedeTiempo('-1Hr')
        } else if (periodicidad === Periodicidad.day) {
            setTextoAvanzaTiempo('+1Día')
            setTextoRetrocedeTiempo('-1Día')
        } else if (periodicidad === Periodicidad.min10) {
            setTextoAvanzaTiempo('+10Min')
            setTextoRetrocedeTiempo('-10Min')
        } else if (periodicidad === Periodicidad.min5) {
            setTextoAvanzaTiempo('+5Min')
            setTextoRetrocedeTiempo('-5Min')
        } else if (periodicidad === Periodicidad.day10) {
            setTextoAvanzaTiempo('+10Dias')
            setTextoRetrocedeTiempo('-10Dias')
        } else if (periodicidad === Periodicidad.month) {
            setTextoAvanzaTiempo('+1Mes')
            setTextoRetrocedeTiempo('-1Mes')
        }
    }, [periodicidad, loading])

    // Creo la coleccion de marcas del slider
    useEffect(() => {
        if (!loading) {
            let fechasAux = fechasMarksCustom ? fechasMarksCustom : fechas

            let newFechasMarks = fechasAux.map((fecha, i) => {
                return {
                    labelForHint: fechasMarksCustom
                        ? fecha
                        : DateUtils.dateToStr(fecha, formato),
                    value: i,
                }
            })
            setFechasMarks(newFechasMarks)
        }
    }, [fechas, loading, fechasMarksCustom])

    function valuetext(value) {
        if (value < fechasMarks.length) return fechasMarks[value].labelForHint
    }

    let slotProps = {}
    if (hintAbajo) {
        slotProps = {
            thumb: {
                'data-value': index,
            },
        }
    }
    const buttons = (
        <>
            <Grid size={BUTTONS_PLAYER_SIZE}>
                <Button
                    disabled={loading}
                    variant="contained"
                    startIcon={<ArrowLeftIcon />}
                    onClick={onClickBack}
                >
                    {textoRetrocedeTiempo}
                </Button>
            </Grid>
            <Grid size={BUTTONS_PLAYER_SIZE}>
                <Button
                    disabled={loading}
                    variant="contained"
                    endIcon={<ArrowRightIcon />}
                    onClick={onClickForward}
                >
                    {textoAvanzaTiempo}
                </Button>
            </Grid>
        </>
    )

    if (fechasMarks.length > 0) {
        return (
            <Grid container spacing={SPACING_SIZE}>
                {buttons}
                <Grid size={8}>
                    <Slider
                        disabled={loading}
                        defaultValue={0}
                        marks={fechasMarks}
                        value={index}
                        valueLabelFormat={valuetext}
                        valueLabelDisplay="on"
                        onChange={(event, value) => {
                            onChange(value)
                        }}
                        track={false}
                        slotProps={slotProps}
                        max={fechasMarks.length - 1}
                    />
                </Grid>
            </Grid>
        )
    } else if (loading) {
        return (
            <Grid container spacing={SPACING_SIZE}>
                {buttons}
                <Grid size={10}>
                    <LinearProgress />
                </Grid>
            </Grid>
        )
    }
    return <></>
}

SliderFechas.propTypes = {
    index: PropTypes.number,
    iFecha: PropTypes.number,
    fechas: PropTypes.array,
    fechasMarksCustom: PropTypes.array,
    onClickForward: PropTypes.func,
    onClickBack: PropTypes.func,
    onChange: PropTypes.func,
    loading: PropTypes.bool,
    periodicidad: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
    formato: PropTypes.string,
    textoRetrocedeTiempoCustom: PropTypes.string,
    textoAvanzaTiempoCustom: PropTypes.string,
    hintAbajo: PropTypes.bool,
}

export { SliderFechas as default }
